let url = window.location.href;
let arr = url.split('/');
const BASE_URL = arr[0] + '//staging.ibottt.com';

module.exports = {
  BASE_URL: BASE_URL,
};
